import React, { Component, Fragment } from "react"
import { Redirect } from "react-router-dom"
import { connect } from "react-redux"
import { compose } from "redux"
import { withRouter } from "react-router"
import { graphql } from "react-apollo"
import { setToken } from "../actions/auth"
import gql from "graphql-tag"
import Helmet from 'react-helmet'
import { Query } from 'react-apollo'
import { setCookie } from '../utilities/helpers'

const mutation = gql`
  mutation OpenQuestionnaire($id: UUID!, $invitationHash: String!) {
    openQuestionnaire(id: $id, invitationHash: $invitationHash) {
      token
      surveyId
    }
  }
`

const query = gql`
  query Questionnaire($languageCode: String) {
    questionnaire(languageCode: $languageCode) {
       languages
    }
  }
`

class SetContext extends Component {
  state = {
    setToken: false,
    surveyId: undefined
  }

  componentDidMount() {
    const { getToken, setToken, match: { params: { participantId, invitationHash } } } = this.props;

    getToken({ variables: { id: participantId, invitationHash } }).then(
      ({ data }) => {
        const { openQuestionnaire: { token, surveyId } } = data;

        setToken(token);
        this.setState({ setToken: true, surveyId });

        // Store the token in a cookie
        setCookie(surveyId, token, 60);
      }
    ).catch((error) => {this.setState({tokenError: error.message})});
  }

  render() {
    const { setToken } = this.state;

    if (!setToken) {
      return (
        <section className="home row">
          <Helmet>
            <body className="home"/>
          </Helmet>
          {this.state.tokenError && this.state.tokenError.replace(/^graphql error:/i, '').trim() === "Respondent is cancelled" &&
            <div className="error-container card">
              <div className="card-body">
                <h3>The survey cannot be opened</h3>
                <p>The survey has already ended and you didn't finish it in time or there is an issue with the invitation link.</p>
                <p>Please contact <a href="mailto:niclas.lindgren@renesans.fi">niclas.lindgren@renesans.fi</a> for a new invitation.</p>
              </div>
            </div>
          }
          {this.state.tokenError && this.state.tokenError.replace(/^graphql error:/i, '').trim() === "Could not find respondent or guest to open a questionnaire" &&
            <div className="error-container card">
              <div className="card-body">
                <h3>The survey cannot be opened</h3>
                <p>
                  This link has expired and you have been sent updated link in the newest REMINDER-message – please use that link to access the self-assessment.
                </p>
                <p>
                  If the problem persists, contact <a href="mailto:niclas.lindgren@renesans.fi">niclas.lindgren@renesans.fi</a>.
                </p>
              </div>
            </div>
          }
        </section>
      );
    }

    return (
      <Query query={query} variables={{ languageCode: "en" }}>
        {({ loading, error, data }) => {
          if (loading) return 'Loading...';
          if (error) {
            const errorText = error.message.replace(/^graphql error:/i, '').trim();
            const surveyNotFound = errorText === "Survey not found";
            return (
              <section className="home row">
                <Helmet>
                  <body className="home"/>
                </Helmet>
                <div className="error-container card">
                  <div className="card-body">
                    {surveyNotFound ?
                      <Fragment>
                        <h3>{errorText}</h3>
                        <p>Survey has been deleted or there is an issue with your invitation link.</p>
                        <p>Please contact the facilitator for a new invitation.</p>
                      </Fragment>
                      :
                      <Fragment>
                        <p className={"text-center"}>{errorText}</p>
                      </Fragment>
                    }
                  </div>
                </div>
              </section>
            )
          }
          const { questionnaire: {languages}} = data;
          const defaultLang = languages.length > 0 ? languages[0] : 'en';

          return <Redirect to={`/${defaultLang}/${this.state.surveyId}`} />
        }}
      </Query>
    )
  }
}

const mapStateToProps = ({ respondent }) => ({ respondent })

const mapDispatchToProps = (dispatch, props) => {
  return {
    setToken: (token) => dispatch(setToken(token)),
  }
}

export default compose(
  withRouter,
  graphql(mutation, { name: "getToken" }),
  connect(mapStateToProps, mapDispatchToProps)
)(SetContext);



// WEBPACK FOOTER //
// ./src/containers/set-respondent-context.js